import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { debounce } from 'utils/common';
import {  useSelector } from 'react-redux';
import {toTitleCase} from "utils/common"
import { createPreSignedUrl } from "api/services/common";
import axios from "axios"

export default function useUploadHook(pageSettings , setPageSettings) {

const [uploadLoading, setUploadLoading] = useState(false)


  const handleFile = async (e, options) => {
    try{
        setUploadLoading(true)
        console.log(e.target.files)
        let document_urls = []
        for (const fileObj of e.target.files) {
          const response = await createPreSignedUrl(fileObj, options)
          console.log(response, "JJ")
          // .then((response) => {
            const formData = new FormData()
            Object.entries(response.fields).forEach(([k, v]) => {
              formData.append(k, v)
            })
            formData.append('file', fileObj)
            const document_url = `${response.url }/${response.fields.key}`
            const documentObject = { url: response.url, formData: formData, document_url }
      
             const uploadFile = await uploadFileToS3(documentObject)
             document_urls.push(document_url)
      }
        // e.target.files.forEach(async fileObj=> {
        //   // const fileObj = e.target.files[0]
        //   const response = await createPreSignedUrl(fileObj)
        //   console.log(response, "JJ")
        //   // .then((response) => {
        //     const formData = new FormData()
        //     Object.entries(response.fields).forEach(([k, v]) => {
        //       formData.append(k, v)
        //     })
        //     formData.append('file', fileObj)
        //     const document_url = response.url + response.fields.key
        //     const documentObject = { url: response.url, formData: formData, document_url }
      
        //      const uploadFile = await uploadFileToS3(documentObject)
        //      document_urls.push(document_url)

             
        // })
        setUploadLoading(false)

        if(document_urls.length==1){
          return document_urls[0]
        }
        return document_urls
           
    }catch(e){
        setUploadLoading(false)

    }


    }
    const uploadFileToS3 = async (obj) => {
        const response = await axios.post(obj.url, obj.formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      
        return response.data
      }


  return {
    uploadLoading,
    handleFile
  };
}
